/**
 * @desc 获取列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(): Promise<BaseResponse<defs.ResultBean<Array<defs.GasStationCollation>>>> {
  return fetch({
    url: config.API_HOST + '/base/resPetrolStationOrderby/findList',
    data: undefined,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
